export const KMS_KEY_TYPES = {
  SYMMETRIC: "SYMMETRIC",
  ASYMMETRIC: "ASYMMETRIC",
};

export const KMS_PROVIDERS = {
  KMS_DB: "KMS_DB",
  GCP_KMS: "GCP_KMS",
};

export const ALGORITHMS = {
  // ---- symmetric ----
  AES_256_GCM: {
    type: KMS_KEY_TYPES.SYMMETRIC,
    name: "AES-GCM",
    keyBytes: 32,
    providers: {
      [KMS_PROVIDERS.KMS_DB]: {},
      [KMS_PROVIDERS.GCP_KMS]: { algorithm: "GOOGLE_SYMMETRIC_ENCRYPTION" },
    },
  },

  // ---- asymmetric (RSA-OAEP) ----
  RSA_2048_OAEP_SHA256: {
    type: KMS_KEY_TYPES.ASYMMETRIC,
    name: "RSA-OAEP",
    modulusLength: 2048,
    oaepHash: "SHA-256",
    providers: {
      [KMS_PROVIDERS.KMS_DB]: {},
      [KMS_PROVIDERS.GCP_KMS]: { algorithm: "RSA_DECRYPT_OAEP_2048_SHA256" },
    },
  },
  RSA_3072_OAEP_SHA256: {
    type: KMS_KEY_TYPES.ASYMMETRIC,
    name: "RSA-OAEP",
    modulusLength: 3072,
    oaepHash: "SHA-256",
    providers: {
      [KMS_PROVIDERS.KMS_DB]: {},
      [KMS_PROVIDERS.GCP_KMS]: { algorithm: "RSA_DECRYPT_OAEP_3072_SHA256" },
    },
  },
  RSA_4096_OAEP_SHA256: {
    type: KMS_KEY_TYPES.ASYMMETRIC,
    name: "RSA-OAEP",
    modulusLength: 4096,
    oaepHash: "SHA-256",
    providers: {
      [KMS_PROVIDERS.KMS_DB]: {},
      [KMS_PROVIDERS.GCP_KMS]: { algorithm: "RSA_DECRYPT_OAEP_4096_SHA256" },
    },
  },
  RSA_4096_OAEP_SHA512: {
    type: KMS_KEY_TYPES.ASYMMETRIC,
    name: "RSA-OAEP",
    modulusLength: 4096,
    oaepHash: "SHA-512",
    providers: {
      [KMS_PROVIDERS.KMS_DB]: {},
      [KMS_PROVIDERS.GCP_KMS]: { algorithm: "RSA_DECRYPT_OAEP_4096_SHA512" },
    },
  },
};
